import React, {  } from 'react';

export default function WhoThisFor() {
  
  return (
    <section className="who" id="program">
      {/* Added Center-Aligned Text */}
<div className="center-container">
  {/* Logo with source text */}
  <div className="logo-wrapper">
    <div className="flex flex-col items-center">
      <img 
        src="https://thebullstrading.com/wp-content/uploads/2025/08/cmt-assoc-removebg-preview.png" 
        alt="CMT Association Logo" 
        className="w-48 md:w-56" 
      />
      <div className="source-text">
        Source: www.cmtassociation.org
      </div>
    </div>
  </div>

  {/* Video */}
  <div className="video-wrapper">
    <div className="video-container">
      <iframe 
        className="video-iframe"
        src="https://www.youtube.com/embed/ma-vS0YI1Fw" 
        title="The CMT Program"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowFullScreen
      />
    </div>
  </div>

  {/* Bulls Trading Academy Info */}
  <div className="text-content">
    <div className="text-inner">
      <div className="who__intro">
        <p className="m-0 leading-relaxed">
        
          <span className="block mb-2">
            Based on the CMT Association curriculum<br/>
          </span>
          <span className="block mb-2">
            🎓 Globally Recognized Credentials<br/>
          </span>
          <span className="block">
            📈 Learn from Certified Experts
          </span>
        </p>
      </div>
    </div>
  </div>
</div>
      <div className="container who__inner">
        <div className="who__text">
          <h2 className="section__title">Who This Is For?</h2>
          <p>
            Our curriculum is tailored for ambitious professionals seeking to advance their careers in technical market analysis expertise. 
            It’s perfect for those aiming to earn the globally recognized CMT designation.
          </p>
          <a href="#contact" className="btn btn--primary">Learn More</a>
        </div>
        <div className="who__visual" role="img" aria-label="Bull and Bear"></div>
      </div>
    </section>
  );
}
